import type { FC, ReactNode } from 'react'

interface AsteriskProps {
    className?: string
}

/** The six-armed brand mark, also used as the favicon. Inherits the current text color. */
export const Asterisk: FC<AsteriskProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' aria-hidden='true' focusable='false' className={className}>
            <rect x='10.3' y='1.5' width='3.4' height='21' rx='1.7' />
            <rect x='10.3' y='1.5' width='3.4' height='21' rx='1.7' transform='rotate(60 12 12)' />
            <rect x='10.3' y='1.5' width='3.4' height='21' rx='1.7' transform='rotate(120 12 12)' />
        </svg>
    )
}
